import {
  DonationListStatusFilterEnum,
  DonationType
} from '@percent/partner-dashboard/services/donation/donationService.types'

export const donationStatusRules = [
  {
    match: {
      type: [DonationType.Matched, DonationType.Wallet, DonationType.Direct, DonationType.Payroll],
      status: [DonationListStatusFilterEnum.Active, DonationListStatusFilterEnum.RequestedPayment]
    },
    show: true,
    currentDescription: 'A donation has been created but the funds have not yet been received.'
  },
  {
    match: {
      type: [DonationType.Hosted],
      status: [DonationListStatusFilterEnum.Active, DonationListStatusFilterEnum.RequestedPayment]
    },
    show: false
  },
  {
    match: {
      type: [DonationType.Matched, DonationType.Wallet, DonationType.Direct, DonationType.Hosted, DonationType.Payroll],
      status: [DonationListStatusFilterEnum.ReceivedPayment, DonationListStatusFilterEnum.Settled]
    },
    show: true,
    currentDescription: 'We have received funds and are ready to pay the nonprofit.'
  },
  {
    match: {
      type: [DonationType.Matched, DonationType.Wallet, DonationType.Direct, DonationType.Hosted, DonationType.Payroll],
      status: [DonationListStatusFilterEnum.CheckSent]
    },
    show: true,
    currentDescription: 'We have sent a check to the nonprofit.'
  },
  {
    match: {
      type: [
        DonationType.Hosted,
        DonationType.Wallet,
        DonationType.Matched,
        DonationType.Direct,
        DonationType.External,
        DonationType.Payroll
      ],
      status: [DonationListStatusFilterEnum.Disbursed]
    },
    show: true,
    currentDescription: 'The donation has been paid to the nonprofit.'
  }
]
